/**
 * Relatórios do Service Desk (redesign console — spec 2026-07-29).
 *
 * Usa `ConsoleLayout` DIRETO (padrão M365): o módulo é exclusivo do design
 * system novo (shadcn + Tailwind), sem versão Vuetify em paralelo. O path
 * `/ticket/relatorios` é PRESERVADO — permissões já semeadas (migration 108)
 * continuam valendo sem migração.
 *
 * `/ticket/relatorios/heatmap` (tela antiga) vira redirect para a aba Operação.
 */
import { defineAsyncComponent } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

// Assíncrono: um import estático puxaria o CSS do design system para o bundle de entrada.
const ConsoleLayout = defineAsyncComponent(() => import('@/layouts/console/ConsoleLayout.vue'));

export const ticketReportsRoutes: RouteRecordRaw[] = [
  {
    path: '/ticket/relatorios',
    component: ConsoleLayout,
    meta: { requiresAuth: true, title: 'Relatório de chamados' },
    children: [
      {
        path: '',
        name: 'TicketRelatorios',
        component: () => import('@/views/Ticket/reports/TicketReportsPage.vue'),
        meta: {
          requiresAuth: true,
          title: 'Relatório de chamados',
          breadcrumb: 'Service Desk / Relatórios',
        },
      },
      {
        path: 'heatmap',
        name: 'TicketHeatmap',
        redirect: { path: '/ticket/relatorios', query: { aba: 'operacao' } },
      },
    ],
  },
];

export default ticketReportsRoutes;
